import { generateClient } from 'aws-amplify/api';
import { timeSheetByUserId } from "../graphql/customQueries";

const client = generateClient();

export default async (userId) => {
    const {
        data: {
            timeSheetByUserId: { items: timesheets },
        },
    } = await client.graphql({
        query: timeSheetByUserId,
        variables: {
            userId,
            sortDirection: "DESC",
        },
    });
    return timesheets;
};
